// =============================================================
// 📈 SLAChart.jsx — SLA por operador
// =============================================================
//
// Espera dados no formato:
// data = [
//   { operator: "Ana", withinSLA: 18, outSLA: 2 },
//   { operator: "Bruno", withinSLA: 10, outSLA: 5 },
//   ...
// ]
//
// Mostramos a % de atendimentos dentro do SLA por operador.
//

import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

function buildChartData(raw) {
  if (!raw || !Array.isArray(raw)) return [];

  return raw.map((item) => {
    const within = Number(item.withinSLA || 0);
    const out = Number(item.outSLA || 0);
    const total = within + out;
    const slaPercent = total > 0 ? Math.round((within / total) * 100) : 0;

    return {
      operator: item.operator || item.name || "—",
      withinSLA: within,
      outSLA: out,
      slaPercent,
    };
  });
}

export default function SLAChart({ data }) {
  const chartData = buildChartData(data);

  if (!chartData || chartData.length === 0) {
    return <div className="ia-chart-empty">Sem dados de SLA ainda.</div>;
  }

  return (
    <div className="ia-chart-wrapper">
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3c5d8" />
          <XAxis
            dataKey="operator"
            tick={{ fontSize: 11, fill: "#b22857" }}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#b22857" }}
            domain={[0, 100]}
            unit="%"
          />
          <Tooltip
            formatter={(value, name) => {
              if (name === "slaPercent") return [`${value}%`, "SLA"];
              if (name === "withinSLA") return [value, "Dentro do SLA"];
              if (name === "outSLA") return [value, "Fora do SLA"];
              return [value, name];
            }}
            labelFormatter={(label) => `Operador: ${label}`}
          />
          <Line
            type="monotone"
            dataKey="slaPercent"
            stroke="#d81b60"
            strokeWidth={2.4}
            dot={{ r: 3, fill: "#d81b60" }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
